/**
 * Created by admin on 2017/3/28.
 */
import {
    GetProvinces,
    GetCitys,
    GetAreas,
    GetAgentList,
    GetParmConfig,
    GetProductClass,
    GetAgentConsigneeList,
    Consignee_Add,
    GetEmployList,
    ConsigneeSetDefault
} from '@api/commonApi.js';
import {
    PackageByPage,
} from '@api/packageApi.js'
import {
    GetProductByPage
} from '@api/productApi.js'
import {
    ERP_OrderAdd,
    GetERP_OrderById,
    ERP_OrderUpdate
} from '../../api/orderApi.js'
import NProgress from 'nprogress'
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';

module.exports = {
    data() {
        return {
            flshow: true,
            zlshow: true,
            maxPageIndex: 1,
            maxPageIndex2: 1, //套餐最大页面
            ProductData: [],
            PackageData: [],
            loading1: false,
            loading3: false,
            loading4: false,
            dialog: {
                addAddressVisible: false, //添加单品
                agentVisible: false, //代理商
                productVisible: false, //选商品
                zengVisible: false, //赠品
            },
            /*----------------------*/
            IsEdit: false,
            sysSid: "",
            sysSession: "",
            ProvinceList: [], //省
            CityList: [], //市
            AreaList: [], //区
            AgentList: [], //代理商列表
            Agent: {}, //选中的代理商
            PayList: [],
            transportList: [],
            showAgent: true,
            isProActive: true, //选择单品
            isPacActive: false,
            query: {
                AgentId: "",
                AgentName: "",
                ProvinceSelcted: "",
                CitySelected: "",
                AreaSelected: "",
            }, //代理商查询
            queryProduct: {
                ProId: "",
                ProName: "",
                ProClass: "",
                ProAttr: ""
            }, //单品查询
            queryPackage: {
                ProCode: "",
                ProName: "",
            }, //赠品查询
            Category: [], //单品分类
            ProductClass: [], //单品种类
            DailogTile: "", //dialog标识标题
            ProductList: [], //单品列表
            PackageList: [], //套餐列表
            DialogProduct: [], //选中的单品
            DialogPackage: [], //选中的套餐数
            GoodsList: [], //被选中的单品套餐
            PageGoodsList: [], //页面商品数量页面数组
            PageGiftsList: [], //页面赠品列表
            checkProList: [], //选单品
            checkPacList: [], //选套餐
            IsGoods: false, //是否点击选择商品
            IsGifts: false, //是否选择赠品
            AddAddress: {
                "Consignee": "",
                "ConsigneeTel": "",
                "ConsigneeAdress": "",
                "IsDefault": true,
            },
            /*--------------------*/
            /*分页*/
            pageIndex: 1,
            pageIndex2: 1,
            pageIndex3: 1,
            pageSize: 25,
            totalSize: '',
            sels: [], //列表选中列
            AgentAddress: [],
            DefaultAddress: {},
            EmployallData: [],
            Form: {
                "AgentId": "",
                "SaleEmployeeId": "",
                "AgentConsigneeId": "",
                "SendMode": "",
                "PayMode": "",
                "OrderRemark": "",
                "GoodsList": [],
                "GiftsList": []
            },
            /*---*/
        }
    },
    methods: {
        //强制ele重新渲染组件
        selChange(val) {
            this.flshow = false;
            this.flshow = true;
            this.zlshow = false;
            this.zlshow = true;
        },
        myRow(val) {
            this.DefaultAddress.Id = val.Id;
            this.DefaultAddress.Address = val.Address;
            this.DefaultAddress.Consignee = val.Consignee;
            this.DefaultAddress.ConsigneeTel = val.ConsigneeTel;
            this.dialog.addAddressVisible = false;
        },
        submit() {
            this.Form.GiftsList = [];
            this.Form.GoodsList = [];
            for (var i = 0; i < this.PageGiftsList.length; i++) {
                var gifts = {};
                gifts.ProId = this.PageGiftsList[i].ProId;
                gifts.ProNum = this.PageGiftsList[i].ProNum;
                this.Form.GiftsList.push(gifts);
            }
            for (var i = 0; i < this.PageGoodsList.length; i++) {
                var gifts = {};
                gifts.ProId = this.PageGoodsList[i].ProId;
                gifts.ProNum = this.PageGoodsList[i].ProNum;
                this.Form.GoodsList.push(gifts);
            }
            this.Form.AgentConsigneeId = this.DefaultAddress.Id;
            this.Form.AgentId = this.Agent.Id;
            if (this.IsEdit) {
                ERP_OrderUpdate(this.Form).then(res => {
                    util.doResult(this, res, () => {
                        this.$notify({
                            title: '成功',
                            message: '更新成功',
                            type: 'success'
                        });
                        this.$router.push('/Order/SaleOrder');
                    });
                });
            } else {
                ERP_OrderAdd(this.Form).then(res => {
                    util.doResult(this, res, () => {
                        this.$notify({
                            title: '成功',
                            message: '添加成功',
                            type: 'success'
                        });
                        this.$router.push('/Order/SaleOrder');
                    });
                });
            }
        },
        addAddress() {
            let paras = {
                "AgentId": this.Agent.Id,
                "Consignee": this.AddAddress.Consignee,
                "ConsigneeTel": this.AddAddress.ConsigneeTel,
                "ConsigneeProvince": this.query.ProvinceSelcted,
                "ConsigneeCity": this.query.CitySelected,
                "ConsigneeArea": this.query.AreaSelected,
                "ConsigneeAdress": this.AddAddress.ConsigneeAdress,
                "IsDefault": this.AddAddress.IsDefault
            };

            Consignee_Add(paras).then(res => {
                util.doResult(this, res, () => {});
                if (res.data.StateCode !== 0) {
                    if (res.data.StateCode == 99) {
                        this.$router.push('/login');
                    } else {
                        this.$notify({
                            title: '错误',
                            message: res.data.StateMsg,
                            type: 'error'
                        });
                    }
                } else {
                    this.dialog.addAddressVisible = false;
                    let Params = {
                        Sid: this.sysSid,
                        Session: this.sysSession,
                        AgentId: this.Agent.Id,
                        CustomerId: 0
                    }
                    GetAgentConsigneeList(Params).then(res => {
                        util.doResult(this, res, () => {
                            this.AgentAddress = res.data.Data;
                            this.DefaultAddress = this.AgentAddress[this.AgentAddress.length - 1];
                        });
                    });
                }
            });

        },
        setDefaultAddress(index, item) {
            let Params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                Id: item.Id,
                AgentId: this.Agent.Id,
                CustomerId: 0
            };
            ConsigneeSetDefault(Params).then(res => {
                util.doResult(this, res, () => {
                    GetAgentConsigneeList(Params).then(res => {
                        util.doResult(this, res, () => {

                            this.AgentAddress = res.data.Data;
                            for (var i = 0; i < this.AgentAddress.length; i++) {
                                if (this.AgentAddress[i].IsDefault == true) {
                                    this.DefaultAddress = this.AgentAddress[i];
                                }
                            }
                            this.dialog.addAddressVisible = false;
                            this.$notify({
                                title: '成功',
                                message: "设置默认地址成功",
                                type: 'success'
                            });

                        });
                    });
                });
            });

        },
        /*-------*/
        AgentSure(num) {
            if (num == 2) {
                if (this.Form.AgentId != '') {
                    for (var i = 0; i < this.AgentList.length; i++) {
                        if (this.AgentList[i].Id == this.Form.AgentId) {
                            this.showAgent = false;
                            this.Agent = this.AgentList[i];
                        }
                    }
                    let Params = {
                        Sid: this.sysSid,
                        Session: this.sysSession,
                        AgentId: this.Agent.Id,
                        CustomerId: 0
                    };
                    GetAgentConsigneeList(Params).then(res => {
                        util.doResult(this, res, () => {
                            this.AgentAddress = res.data.Data;
                            let hasDefaultsAddress = 0;
                            for (var i = 0; i < this.AgentAddress.length; i++) {
                                if (this.AgentAddress[i].IsDefault == true) {
                                    this.DefaultAddress = this.AgentAddress[i];
                                    hasDefaultsAddress = 1;
                                }
                            }
                            if (hasDefaultsAddress == 0) {
                                this.DefaultAddress = this.AgentAddress[0];
                            }
                            this.Form.AgentId = "";
                        });
                    });
                }
            }
            this.dialog.agentVisible = false;
        },
        /*-------*/
        tagClose(item) {
            for (var i = 0; i < this.GoodsList.length; i++) {
                if (this.GoodsList[i].Type == item.Type && this.GoodsList[i].ProId == item.ProId) {
                    this.GoodsList.splice(i, 1);
                    if (item.Type == 1) {
                        for (var m = 0; m < this.checkProList.length; m++) {
                            if (this.checkProList[m] == item.ProId) {
                                this.checkProList.splice(m, 1);
                            }
                        }
                    } else {
                        for (var m = 0; m < this.checkPacList.length; m++) {
                            if (this.checkPacList[m] == item.ProId) {
                                this.checkPacList.splice(m, 1);
                            }
                        }
                    }
                }
            }
        },
        //单品-复选框列表-点击事件
        checkProduct(item) {
            //清除原来的选中的单品
            if (this.GoodsList.length > 0) {
                for (var i = this.GoodsList.length - 1; i >= 0; i--) {
                    if (this.GoodsList[i].Type == 1) {
                        this.GoodsList.splice(i, 1);
                    }
                }
            }
            var eachItem = [];
            for (var m = 0; m < item.length; m++) {
                var a = {};
                for (var i = 0; i < this.ProductData.length; i++) {
                    if (this.ProductData[i].ProductId == item[m]) {
                        a.ProName = this.ProductData[i].ProName;
                        a.ProId = item[m];
                        a.Type = 1;
                        a.ProNum = 1;
                        a.Price = this.ProductData[i].Price;
                        a.SalePrice = this.ProductData[i].SalePrice;
                        a.Total = this.ProductData[i].SalePrice;
                    }
                }
                eachItem.push(a)
            }

            this.GoodsList = this.GoodsList.concat(eachItem);

        },
        //套餐-复选框列表-点击事件
        checkPackage(item) {
            //清除原先选中的套餐
            if (this.GoodsList.length > 0) {
                for (var i = this.GoodsList.length - 1; i >= 0; i--) {
                    if (this.GoodsList[i].Type == 2) {
                        this.GoodsList.splice(i, 1);
                    }
                }
            }
            var eachItem = [];
            for (var m = 0; m < item.length; m++) {
                var a = {};
                for (var i = 0; i < this.PackageData.length; i++) {
                    if (this.PackageData[i].ProductId == item[m]) {
                        a.ProName = this.PackageData[i].ProName;
                        a.ProId = item[m];
                        a.Type = 2;
                        a.ProNum = 1;
                        a.Price = this.PackageData[i].Price;
                        a.SalePrice = this.PackageData[i].SalePrice;
                        a.Total = this.PackageData[i].SalePrice;
                    }
                }
                eachItem.push(a);
            }
            this.GoodsList = this.GoodsList.concat(eachItem);
        },
        handleChangeGoods(item) {
            this.$nextTick(() => {
                item.Total = item.SalePrice * (item.ProNum);
            });
        },
        /**
         *单品-套餐 - 模态窗口-关闭事件 
         * @param {int} num :
         */
        GoodsSure(num) {
            if (num == 2) {
                if (this.IsGoods) {
                    this.PageGoodsList = this.PageGoodsList.concat(this.GoodsList);
                    var unique = {};
                    this.PageGoodsList.forEach(function (gpa) {
                        unique[JSON.stringify(gpa)] = gpa;
                    });
                    this.PageGoodsList = Object.keys(unique).map(function (u) {
                        return JSON.parse(u);
                    });
                } else {
                    this.PageGiftsList = this.PageGiftsList.concat(this.GoodsList);
                    var unique = {};
                    this.PageGiftsList.forEach(function (gpa) {
                        unique[JSON.stringify(gpa)] = gpa;
                    });
                    this.PageGiftsList = Object.keys(unique).map(function (u) {
                        return JSON.parse(u);
                    });
                }
            }
            this.IsGoods = false;
            this.IsGifts = false;
            this.queryProduct = {};
            this.queryPackage = {};
            this.GoodsList = [];
            this.checkProList = []; //选中的单品
            this.checkPacList = []; //选中的套餐
            this.dialog.productVisible = false;

        }, //选择商品确定按钮
        delGoods(item) {
            for (var i = 0; i < this.PageGoodsList.length; i++) {
                if (this.PageGoodsList[i].Type == item.Type && this.PageGoodsList[i].ProId == item.ProId) {
                    this.PageGoodsList.splice(i, 1);
                }
            }
        }, //删除商品
        delGifts(item) {
            for (var i = 0; i < this.PageGiftsList.length; i++) {
                if (this.PageGiftsList[i].Type == item.Type && this.PageGiftsList[i].ProId == item.ProId) {
                    this.PageGiftsList.splice(i, 1);
                }
            }
        }, //删除赠品
        getClass: function () {
            if (this.ProductClass.length > 0) {
                return;
            }
            var Params = {
                Sid: this.sysSid,
                Session: this.sysSession
            };

            GetProductClass(Params).then(res => {
                util.doResult(this, res, () => {
                    this.ProductClass = res.data.Data;
                    this.ProductClass.splice(0, 0, {
                        Key: "全部",
                        Value: "All"
                    });
                });
            })
        }, //获取种类
        getCategory() {
            if (this.Category.length > 0) {
                return;
            }
            var Params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                ParmType: 1
            };
            GetParmConfig(Params).then(res => {
                util.doResult(this, res, () => {});
                if (res.data.StateCode !== 0) {
                    if (res.data.StateCode == 99) {
                        this.$router.push('/login')
                    } else {
                        this.$notify({
                            title: '错误',
                            message: res.data.StateMsg,
                            type: 'error'
                        });
                    }
                } else {
                    this.Category = res.data.Data;
                    this.Category.splice(0, 0, {
                        Id: "All",
                        ParmName: "全部"
                    });
                }
            })
        }, //获取分裂
        activePro() {
            //单品种类
            this.isProActive = true;
            this.isPacActive = false
            this.getClass();
            this.getCategory();
            this.getProList();
            this.DailogTile = '选择单品'
        },
        // 选择商品-----选择单品
        getProList() {
            this.PackageList = [];
            var Params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                pageIndex: this.pageIndex2,
                pageSize: this.pageSize,
                Enable: 0
            };
            if (this.queryProduct.ProId != "") {
                Params.ProCode = this.queryProduct.ProId;
            }
            if (this.queryProduct.ProName != "") {
                Params.ProName = this.queryProduct.ProName;
            }
            if (this.queryProduct.ProClass != "" && this.queryProduct.ProClass != "All") {
                Params.ProClass = this.queryProduct.ProClass;
            }
            if (this.queryProduct.ProAttr != "" && this.queryProduct.ProAttr != "All") {
                Params.ProCategory = this.queryProduct.ProAttr;
            }
            this.loading3 = true;
            GetProductByPage(Params).then(res => {
                util.doResult(this, res, () => {});
                if (res.data.StateCode !== 0) {
                    if (res.data.StateCode == 99) {
                        this.$router.push('/login')
                    } else {
                        this.$notify({
                            title: '错误',
                            message: res.data.StateMsg,
                            type: 'error'
                        });
                    }
                } else {
                    this.loading3 = false;
                    this.totalSize = res.data.Cnt;
                    this.ProductList = res.data.Data;
                    if (this.maxPageIndex == 1) {
                        this.ProductData = res.data.Data;
                    }
                }
            });
        }, //查询单品列表
        activePac() {
            this.isProActive = false;
            this.isPacActive = true;
            this.getPacList();
            this.DailogTile = '选择套餐'
        }, //选择商品-----选择套餐
        getPacList() {
            this.ProductList = [];
            var Params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                pageIndex: this.pageIndex3,
                pageSize: this.pageSize,
                Enable: 0
            };
            if (this.queryPackage.ProCode != "") {
                Params.ProCode = this.queryPackage.ProCode;
            }
            if (this.queryPackage.ProName != "") {
                Params.ProName = this.queryPackage.ProName;
            }
            this.loading1 = true;
            PackageByPage(Params).then(res => {
                util.doResult(this, res, () => {});
                if (res.data.StateCode !== 0) {
                    if (res.data.StateCode == 99) {
                        this.$router.push('/login')
                    } else {
                        this.$notify({
                            title: '错误',
                            message: res.data.StateMsg,
                            type: 'error'
                        });
                    }
                } else {
                    this.loading1 = false;
                    this.totalSize = res.data.Cnt;
                    this.PackageList = res.data.Data;
                    if (this.maxPageIndex2 == 1) {
                        this.PackageData = res.data.Data;
                    }
                }
            })
        },
        ProHandleSizeChange: function (val) {
            this.pageSize = val;
            if (this.isPacActive == true) {
                this.getPacList();
            } else {
                this.getProList();
            }
        },
        ProHandleCurrentChange: function (val) {
            this.pageIndex = val;
            if (this.isPacActive == true) {
                this.getPacList();
            } else {
                this.getProList();
            }
        },
        //获取套餐列表
        handleSizeChange: function (val) {
            this.pageSize = val;
            this.getAgentList();
        }, //分页选定行
        handleCurrentChange: function (val) {
            this.pageIndex = val;
            this.getAgentList();
        }, //分页监听页面
        handleCurrentChange2: function (val) {
            if (this.isProActive) {
                this.pageIndex2 = val;
                this.getProList();
            }
        }, //分页监听页面
        handleCurrentChange3: function (val) {
            if (!this.isProActive) {
                this.pageIndex3 = val;
                this.getPacList();
            }
        }, //分页监听页面
        selsChange: function (sels) {
            this.sels = sels;
        },
        agentShow() {
            this.query = {
                AgentId: "",
                AgentName: "",
                ProvinceSelcted: "",
                CitySelected: "",
                AreaSelected: "",
                activeCustomer: "",
            };
            this.GetProvinces();
            this.dialog.agentVisible = true;
            this.getAgentList();

        }, //点击代理商函数初始化
        AddressShow() {
            this.dialog.addAddressVisible = true;
            this.AddAddress = {
                "Consignee": "",
                "ConsigneeTel": "",
                "ConsigneeAdress": "",
                "IsDefault": true
            };
            this.query.ProvinceSelcted = "";
            this.query.CitySelected = "";
            this.query.AreaSelected = "";
            this.GetProvinces();
        },
        getAgentList() {
            let Params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                pageIndex: this.pageIndex,
                pageSize: this.pageSize
            }

            if (this.query.AgentId != "") {
                Params.Code = this.query.AgentId;
            }
            if (this.query.AgentName != "") {
                Params.Name = this.query.AgentName;
            }
            if (this.query.ProvinceSelcted != "") {
                Params.ProvinceId = this.query.ProvinceSelcted;
            }
            if (this.query.CitySelected != "") {
                Params.CityId = this.query.CitySelected;
            }
            if (this.query.AreaSelected != "") {
                Params.AreaId = this.query.AreaSelected;
            }

            if (!util.checkNumber(this.query.AgentId)) {
                this.$notify.error({
                    title: '错误',
                    message: '代理商编号必须为数字！'
                });
                return;
            }

            this.loading4 = true;
            GetAgentList(Params).then(res => {
                util.doResult(this, res, () => {});
                if (res.data.StateCode !== 0) {
                    if (res.data.StateCode == 99) {
                        this.$router.push('/login')
                    } else {
                        this.$notify({
                            title: '错误',
                            message: res.data.StateMsg,
                            type: 'error'
                        });
                    }
                } else {
                    this.loading4 = false;
                    this.AgentList = res.data.Data;
                    this.totalSize = res.data.Cnt;
                }
            })
        }, //获取代理商列表
        Province() {
            this.query.CitySelected = "";
            this.query.AreaSelected = "";
            if (this.query.ProvinceSelcted != "") {
                let Params = {
                    Sid: this.sysSid,
                    Session: this.sysSession,
                    ProvinceId: this.query.ProvinceSelcted
                };
                GetCitys(Params).then(res => {
                    util.doResult(this, res, () => {});
                    if (res.data.StateCode !== 0) {
                        if (res.data.StateCode == 99) {
                            this.$router.push('/login')
                        } else {
                            this.$notify({
                                title: '错误',
                                message: res.data.StateMsg,
                                type: 'error'
                            });
                        }
                    } else {
                        this.CityList = res.data.Data;
                    }
                })
            }

        }, //监听省获取市
        City() {
            this.query.AreaSelected = "";
            if (this.query.CitySelected != "") {
                let Params = {
                    Sid: this.sysSid,
                    Session: this.sysSession,
                    CityId: this.query.CitySelected
                };
                GetAreas(Params).then(res => {
                    util.doResult(this, res, () => {});
                    if (res.data.StateCode !== 0) {
                        if (res.data.StateCode == 99) {
                            this.$router.push('/login')
                        } else {
                            this.$notify({
                                title: '错误',
                                message: res.data.StateMsg,
                                type: 'error'
                            });
                        }
                    } else {
                        this.AreaList = res.data.Data;
                    }
                })
            }

        }, //监听市获取区
        GetProvinces() {
            let Params = {
                Sid: this.sysSid,
                Session: this.sysSession
            }

            GetProvinces(Params).then(res => {
                util.doResult(this, res, () => {});
                if (res.data.StateCode != 0) {
                    if (res.data.StateCode == 99) {
                        this.$router.push('/login')
                    } else {
                        this.$notify({
                            title: "错误",
                            message: res.data.StateMsg,
                            teyp: 'error'
                        })
                    }
                } else {
                    this.ProvinceList = res.data.Data;
                }
            })
        }, //获取省份
        ActionProduct() {
            this.dialog.productVisible = true;
            this.activePro();
            this.IsGoods = true;
        }, //选择单品
        ActionGifts() {
            this.dialog.productVisible = true;
            this.activePro();
            this.IsGifts = true;
        }, //选择赠品
        /*支付，寄送*/
        getPay(type) {
            let Params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                ParmType: type
            }
            GetParmConfig(Params).then(res => {
                util.doResult(this, res, () => {
                    if (type == 9) {
                        this.PayList = res.data.Data;
                    } else {
                        this.transportList = res.data.Data;
                    }
                });
            });
        }
    },
    watch: {
        pageIndex2: function (newValue, OldValue) {
            if (newValue > this.maxPageIndex) {
                this.maxPageIndex = newValue;
                /*-----------*/
                var Params = {
                    Sid: this.sysSid,
                    Session: this.sysSession,
                    pageSize: this.pageSize * this.maxPageIndex,
                    Enable: 0
                };
                if (this.queryProduct.ProId != "") {
                    Params.ProCode = this.queryProduct.ProId;
                }
                if (this.queryProduct.ProName != "") {
                    Params.ProName = this.queryProduct.ProName;
                }
                if (this.queryProduct.ProClass != "" && this.queryProduct.ProClass != "All") {
                    Params.ProClass = this.queryProduct.ProClass;
                }
                if (this.queryProduct.ProAttr != "" && this.queryProduct.ProAttr != "All") {
                    Params.ProCategory = this.queryProduct.ProAttr;
                }
                this.loading3 = true;
                GetProductByPage(Params).then(res => {
                    util.doResult(this, res, () => {});
                    if (res.data.StateCode !== 0) {
                        if (res.data.StateCode == 99) {
                            this.$router.push('/login')
                        } else {
                            this.$notify({
                                title: '错误',
                                message: res.data.StateMsg,
                                type: 'error'
                            });
                        }
                    } else {
                        this.ProductData = res.data.Data;
                    }
                });
                /*-------------*/
            }

        },
        pageIndex3: function (newV, OldV) {
            if (newV > this.maxPageIndex2) {
                this.maxPageIndex2 = newV;

                var Params = {
                    Sid: this.sysSid,
                    Session: this.sysSession,
                    pageSize: this.pageSize * this.maxPageIndex2,
                    Enable: 0
                };
                if (this.queryPackage.ProCode != "") {
                    Params.ProCode = this.queryPackage.ProCode;
                }
                if (this.queryPackage.ProName != "") {
                    Params.ProName = this.queryPackage.ProName;
                }
                this.loading1 = true;
                PackageByPage(Params).then(res => {
                    util.doResult(this, res, () => {});
                    if (res.data.StateCode !== 0) {
                        if (res.data.StateCode == 99) {
                            this.$router.push('/login')
                        } else {
                            this.$notify({
                                title: '错误',
                                message: res.data.StateMsg,
                                type: 'error'
                            });
                        }
                    } else {
                        this.PackageData = res.data.Data;
                        this.flshow = false;
                        this.flshow = true;
                        this.zlshow = false;
                        this.zlshow = true;
                    }
                });
            }
        }
    },
    computed: {},
    created() {
        var user = sessionStorage.getItem("user");
        if (user) {
            user = JSON.parse(user);
            this.sysSid = user.Sid || '';
            this.sysSession = user.Session || '';
        }

        this.getPay(9);
        this.getPay(8);

        var params = {
            Sid: this.sysSid,
            Session: this.sysSession,
            pageIndex: 1,
            pageSize: 2000,
            orderBy: this.orderBy,
            Name: ''
        };

        GetEmployList(params).then(res => {
            util.doResult(this, res, () => {});
            if (res.data.StateCode !== 0) {
                if (res.data.StateCode == 99) {
                    this.$router.push('/login')
                } else {
                    this.$notify({
                        title: '错误',
                        message: res.data.StateMsg,
                        type: 'error'
                    });
                }
            } else {
                this.EmployallData = res.data.Data
            }
        });

        if (this.$route.query.Id != undefined) {
            this.IsEdit = true;
            let param = {
                Sid: this.sysSid,
                Session: this.sysSession,
                Id: this.$route.query.Id
            }
            GetERP_OrderById(param).then(res => {
                util.doResult(this, res, () => {});
                if (res.data.StateCode !== 0) {
                    if (res.data.StateCode == 99) {
                        this.$router.push('/login')
                    } else {
                        this.$notify({
                            title: '错误',
                            message: res.data.StateMsg,
                            type: 'error'
                        });
                    }
                } else {
                    var Data = res.data.Data;
                    for (var i = 0; i < Data.GiftList.length; i++) {
                        var a = {};
                        a.ProName = Data.GiftList[i].ProductName;
                        a.ProId = Data.GiftList[i].ProId;
                        a.ProNum = Data.GiftList[i].ProNum;
                        a.Type = "2";
                        this.PageGiftsList.push(a)
                    }

                    for (var i = 0; i < Data.ProductList.length; i++) {
                        var a = {};
                        a.ProName = Data.ProductList[i].ProductName;
                        a.ProId = Data.ProductList[i].ProId;
                        a.ProNum = Data.ProductList[i].ProNum;
                        a.Price = Data.ProductList[i].Price;
                        a.SalePrice = Data.ProductList[i].SalePrice;
                        a.Total = Data.ProductList[i].Total;
                        a.Type = "1";
                        this.PageGoodsList.push(a)
                    }

                    this.DefaultAddress.Id = Data.AgentConsigneeId;
                    this.DefaultAddress.Address = Data.AgentConsignee;
                    this.DefaultAddress.Consignee = Data.Consignee
                    this.DefaultAddress.ConsigneeTel = Data.ConsigneeTel;
                    this.Form.OrderId = Data.OrderId;
                    this.Form.OrderRemark = Data.OrderRemark;
                    this.Form.PayMode = Data.PayMode;
                    this.Form.SendMode = Data.SendMode;
                    this.Form.AgentId = Data.AgentId;
                    this.Form.SaleEmployeeId = Data.SaleEmployeeId;

                    let Params = {
                        Sid: this.sysSid,
                        Session: this.sysSession,
                        AgentId: Data.AgentId,
                        CustomerId: 0
                    };
                    let Param = {
                        Sid: this.sysSid,
                        Session: this.sysSession,
                        pageIndex: this.pageIndex,
                        pageSize: 200
                    };

                    GetAgentList(Param).then(res => {
                        util.doResult(this, res, () => {
                            this.AgentList = res.data.Data;
                            for (var i = 0; i < this.AgentList.length; i++) {
                                if (this.AgentList[i].Id == this.Form.AgentId) {
                                    this.showAgent = false;
                                    this.Agent = this.AgentList[i];
                                }
                            }
                            GetAgentConsigneeList(Params).then(res => {
                                util.doResult(this, res, () => {
                                    this.AgentAddress = res.data.Data;
                                    if (JSON.stringify(this.DefaultAddress) == '{}') {
                                        for (var i = 0; i < this.AgentAddress.length; i++) {
                                            if (this.AgentAddress[i].IsDefault == true) {
                                                this.DefaultAddress = this.AgentAddress[i];
                                            }
                                        }
                                    }
                                    this.Form.AgentId = "";
                                });
                            });
                        });
                    });
                }
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/Order/addOrder.js